import React, { useEffect, useState, useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';

const NodeTree:React.FC<IProps> = (props) => {

  return (
    <S.Root>
      <S.LayerNameContainer
        style={{
          border: props.child.id === props.globalClicked ? `1px solid white` : ''
        }}
        onClick={() => {
          props.setGlobalClicked(props.child.id);
          //This console.info will be used to browse through the psd tree in order to look at the raw properties of each element
          console.info(props.child);
        }}
      >
        <S.LayerName>
          {props.child?.name}
          {
            props.child?.text &&
            <S.TextLayer>
              {`[Text] ${props.child.text.text}`}
            </S.TextLayer>
          }
        </S.LayerName>
        <S.OptionsContainer>
          {
            props.child.canvas &&
            <S.LayerPreview
              src={props.child.canvas}
            />
          }
          {
            props.child.mask?.canvas &&
            <S.LayerPreview
            src={props.child.mask.canvas}
            />
          }
          <S.HideButton
            onClick={() => props.handleHidden(props.child.id)}
            color={props.child.hidden ? 'red' : 'green'}
          />
        </S.OptionsContainer>
      </S.LayerNameContainer>
      <S.ChildrenContainer>
        {props.children}
      </S.ChildrenContainer>
    </S.Root>
  );
}

export default NodeTree;